import BaseApi from "../Core/BaseApi";

export default class RecentlyViewedDataAccess extends BaseApi{
	
	public static AddRecentlyViewd(product:any,callback:any){
		this.BaseURLPostRequest("customer/recently-viewed-products",product,callback);
	}
}